export const UPDATE_HYP_STDOUT = 'UPDATE_HYP_STDOUT';
export const UPDATE_HYP_STDERR = 'UPDATE_HYP_STDERR';
export const UPDATE_HYP_STATUS = 'UPDATE_HYP_STATUS';
export const SET_TEST_SUMMARY_PORT = 'SET_TEST_SUMMARY_PORT';
export const CLEAR_HYP_STDOUT = 'CLEAR_HYP_STDOUT';
export const CLEAR_HYP_STDERR = 'CLEAR_HYP_STDERR';
export const SET_JOB_INFO = 'SET_JOB_INFO';
export const UPDATE_HYP_STATUS_SSE = 'UPDATE_HYP_STATUS_SSE';
export const CLEAR_HYP_FOLDER_PATH = 'CLEAR_HYP_FOLDER_PATH';
export const TEST_RUNNNIG_BIN_STOPPED = 'TEST_RUNNNIG_BIN_STOPPED';

export const hyExSetJobInfo = (payload: object) => ({
  type: SET_JOB_INFO,
  payload,
});

export const updateHypStdout = (payload: object) => ({
  type: UPDATE_HYP_STDOUT,
  payload,
});

export const clearHypStdout = (payload: object) => ({
  type: CLEAR_HYP_STDOUT,
  payload,
});

export const clearHypStderr = (payload: object) => ({
  type: CLEAR_HYP_STDERR,
  payload,
});

export const updateHypStderr = (payload: object) => ({
  type: UPDATE_HYP_STDERR,
  payload,
});

export const updateHypStatus = (payload: object) => ({
  type: UPDATE_HYP_STATUS,
  payload,
});

export const updateHypStatusFromSSE = (payload: object) => ({
  type: UPDATE_HYP_STATUS_SSE,
  payload,
});

export const setTestSummaryPort = (payload: object) => ({
  type: SET_TEST_SUMMARY_PORT,
  payload,
});

export const clearHypFolderPath = (payload: object) => ({
  type: CLEAR_HYP_FOLDER_PATH,
  payload,
});

export const updateTestRunningBinStopped = (payload: object) => ({
  type: TEST_RUNNNIG_BIN_STOPPED,
  payload,
});
